export var getDefaultFormFields = function getDefaultFormFields(t) {
  return [{
    name: t('firstName'),
    slug: 'firstName',
    dataType: 'text',
    isRequired: true,
    pos: 0
  }, {
    name: t('lastName'),
    slug: 'lastName',
    dataType: 'text',
    isRequired: true,
    pos: 1
  }, {
    name: t('email'),
    slug: 'email',
    dataType: 'email',
    isRequired: true,
    pos: 2
  }, {
    name: t('emailConfirm'),
    slug: 'emailConfirm',
    dataType: 'email',
    isRequired: true,
    pos: 3
  }];
};
export var getDefaultPaymentConfig = function getDefaultPaymentConfig() {
  return {
    countryCode: 'ES',
    channel: 'web',
    currency: 'EUR',
    colorDepth: screen.colorDepth,
    javaEnabled: false,
    browserLanguage: navigator.language,
    screenHeight: screen.height,
    screenWidth: screen.width,
    timeZoneOffset: new Date().getTimezoneOffset(),
    originUrl: window.location.origin,
    redirectUrl: window.location.href.split('#').slice(0, 2).join('#')
  };
};
export var measures = {
  GRID_COLUMNS: ['1fr', '1fr', '1fr 1fr'],
  TITLE_FONT: [7, 7, 5]
};
export var baseScriptUrl = 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.23.0/adyen';
export var cardStyle = {
  base: {
    color: '#36424a',
    letterSpacing: 'normal',
    fontSize: '16px',
    fontFamily: 'Avenir',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: '24px'
  },
  placeholder: {
    color: '#6e7a83',
    letterSpacing: 'normal',
    fontSize: '16px',
    fontFamily: 'Avenir',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal'
  }
};